/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import ButtonCell from '@/backgrid/ButtonCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import PageableCollection from '@/backbone/PageableCollection';

const CorrespondenceGridView = GridView.extend({
  initialize() {
    this.options.columns = [
      {
        name: 'filingId',
        label: 'Filing ID',
        cell: StringCell,
        headerCell: 'custom',
        editable: false
      },
      {
        name: 'category',
        label: 'Category',
        cell: StringCell,
        headerCell: 'custom',
        editable: false
      },
      {
        name: 'title',
        label: 'Title',
        cell: StringCell,
        headerCell: 'custom',
        editable: false
      },
      {
        name: 'dueDate',
        label: 'Due Date',
        cell: DateCell,
        headerCell: 'custom',
        editable: false
      },
      {
        name: 'status',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        editable: false
      },
      {
        name: '',
        label: '',
        editable: true,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary'
        })
      },
      {
        name: '',
        label: '',
        editable: true,
        cell: ButtonCell.extend({
          name: 'Do Something',
          buttonClass: 'btn-sm btn-outline-primary',
          onClick: this.onClickOpen
        })
      }
    ];
    this.collection = new PageableCollection(this.model.get('correspondences'), { pageSize: 25 });
    this.options.emptyText = 'No Correspondence';
    GridView.prototype.initialize?.apply(this, this.options);
  },

  onClickOpen(e, model) {
    console.log(model.toJSON());
  }
});
export default CorrespondenceGridView;
